import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";
import {listFromMap} from "../../../helper/list.helper";

@Component({
  selector: 'app-reset-token-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './reset-token-edit.component.html',
  styleUrl: './reset-token-edit.component.scss'
})
export class ResetTokenEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  managerList: {value: string; label: string}[] = [];

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected cdr: ChangeDetectorRef,
              protected crudService: CrudService) {

    this.crudService.getList('manager', 'id', 'nickname').then(data => {
      this.managerList = listFromMap(data);

      this.cdr.detectChanges();
    });
  }

  editLink = '/dashboard/reset-token-edit/';
  menuLink = '/dashboard/reset-token';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'reset-token';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {} as any;
    }
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New Manager Role)',
        configs: [
          {field: 'token', name: 'Role Name', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'attempts', name: 'Settings', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'sendAt', name: 'Send At', type: EInputType.DATETIME, validators: [Validators.required]},
          {field: 'managerId', name: 'Manager Id', type: EInputType.SELECT, options: () => this.managerList, validators: [Validators.required]},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      this.editConfig.groups[0].name = 'General (Manager Role ' + item.name + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
